import { Component, OnInit, TrackByFunction } from '@angular/core';
import { ActionCenterService } from './service/action-center.service';
import { ContractModel } from 'src/app/global/contract-filter-model';
import { FiltersService } from 'src/app/core/services/filters.service';
import { Router } from '@angular/router';
import { ActionState } from './types/action-center-types';
import { isValidEnumValue } from 'src/app/utils/helper';
import { PageStateModel } from './types/page-state-model';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-action-center',
    templateUrl: './action-center.component.html',
    styleUrls: ['./action-center.component.scss'],
    standalone: false
})
export class ActionCenterComponent implements OnInit {

  dataLoading: boolean = true;
  currPageState: ActionState = ActionState.Recommended;

  pageDataObservableSubscription: Subscription | undefined;
  pageStateSubscription : Subscription | undefined;

  tabs = [
    { id: 'my-actions-tab', name: 'My Actions' },
    { id: 'recommendations-tab', name: 'Recommended' },
    { id: 'dismissed-tab', name: 'Dismissed' },
    { id: 'completed-tab', name: 'Completed' },
    { id: 'snoozed-tab', name: 'Snoozed' }
  ];

  trackByFn: TrackByFunction<any> = (index, item) => item.id;

  constructor(
    private acService: ActionCenterService,
    private _filterService: FiltersService,
    private _router: Router,
  ) { }

  filters: ContractModel | undefined;
  pageData: PageStateModel | undefined;

  ngOnInit(): void {
    // Get the filters selected
    this._filterService.selectedFiltersObservable.subscribe(f => this.filters = f);

    if (this.filters == undefined) {
      alert('Please apply filters before navigating to Action Center');
      this._router.navigate(['/filter']);
    }
    else {
      this.pageDataObservableSubscription = this.acService.pageDataObservable.subscribe(pageData => {
        this.pageData = pageData;
      });

      // subscribe to the page state
      this.pageStateSubscription = this.acService.pageState.subscribe(state => {
        this.currPageState = state;
        // update the content for the page state
        this.updateContentForPageStateAsync();
      });
    }
  }

  ngOnDestroy(): void {
    // destroy subscriptions
    this.pageDataObservableSubscription?.unsubscribe();
    this.pageStateSubscription?.unsubscribe();
  }

  private async updateContentForPageStateAsync(): Promise<void> {
    try {
      this.dataLoading = true;
      await this.acService.updateContentForPageState();
      this.dataLoading = false;
    } catch (error) {
      this.acService._handleError('Error fetching data for the page state', error);
    }
  }

  changeTab(tab: string) {
    if (!isValidEnumValue(ActionState, tab)) throw new Error('Invalid tab value');

    // set the observable
    this.acService.pageState.next(tab as ActionState);
  }

}
